import { Container, Grid } from '@mui/material';
import ResetPassword from '../../components/ResetPassword';

const ResetPasswordPage = () => {
  return (
    <Container sx={{ padding: '120px 0' }}>
      <Grid
        container
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        sx={{ marginBottom: '2em' }}
        gap={4}
      >
        <ResetPassword />
      </Grid>
    </Container>
  );
};

export default ResetPasswordPage;
